import React, {useState} from 'react';
import '../../../../assets/stylesheets/Dialogs/Purchase.scss';
import Sapphires from '../../../Shop/components/Sapphires';
import TabSwitcher from '../../../Units/TabSwitcher';
import Chips from './Chips';
const Exchange =({ }) => {
    const tabs = [
        {name: 'chips', view: Chips},
        {name: 'sapphires', view: Sapphires}
    ];
    return (
        <div className={`exchangeDialog `}>
            <TabSwitcher tabs ={tabs} />
        </div> 
    );
};

export default Exchange;

